prismanoteApp.controller('adminTransactionImportController', ['$scope', 'dialogs', '$api', '$uibModal',
  function ($scope, dialogs, $api, $uibModal) {
    $scope.upload = function () {

    }
  }])
